module.exports = __webpack_public_path__ + "static/cbci-lifeworks-logo-48fbf4c128f6d0f6db68dc5181be6699.png";